import React, { useEffect } from 'react';
import { BrowserRouter, HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';

import NeuralGlassHomepage from './components/NeuralGlassHomepage';
import InterviewAssistant from './components/InterviewPage';
import CoverLetter from './components/CoverLetterPage';
import InterviewQuestions from './components/InterviewQuestionsPage';
import BuildResume from './components/ResumeBuilderPage';
import CareerPathAdvisor from './components/CareerPathAdvisor';
import ATSCheckPage from './components/ATSCheckPage';
import Dashboard from './components/Dashboard';
import PaymentSuccess from './components/PaymentSuccess';
import MockInterviewPage from './components/MockInterviewPage';
import ProfilePage from './components/ProfilePage';
import LinkedInOptimizer from './components/LinkedInOptimizerPage';
import AutoJobApply from './components/AutoJobApply';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import About from './components/About';
import FloatingOverlay from './components/FloatingOverlay';
import CertificationPage from './components/CertificationPage';
import PortfolioPage from './components/PortfolioPage';
import PublicPortfolioPage from './components/PublicPortfolioPage';

import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const isElectron = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isElectronUA = userAgent.includes('electron');
  const hasProcess = window.process && window.process.type;
  return isElectronUA || !!hasProcess;
};

const RouterComponent = isElectron() ? HashRouter : BrowserRouter;

function App() {
  return (
    <UserProvider>
      <RouterComponent>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<NeuralGlassHomepage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/InterviewAssistant" element={<InterviewAssistant />} />
            <Route path="/BuildResume" element={<BuildResume />} />
            <Route path="/CoverLetter" element={<CoverLetter />} />
            <Route path="/InterviewQuestions" element={<InterviewQuestions />} />
            <Route path="/CareerPathAdvisor" element={<CareerPathAdvisor />} />
            <Route path="/ATSCheck" element={<ATSCheckPage />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/mockInterview" element={<MockInterviewPage />} />
            <Route path="/LinkedInOptimizer" element={<LinkedInOptimizer />} />
            <Route path="/AutoJobApply" element={<AutoJobApply />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/about" element={<About />} />
            <Route path="/floating" element={<FloatingOverlay />} />
            <Route path="/certification" element={<CertificationPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/p/:slug" element={<PublicPortfolioPage />} />
          </Routes>
        </div>
      </RouterComponent>
    </UserProvider>
  );
}

export default App;
